import React from "react";
import Link from "next/link";
import { gamesPerPage } from "../config";

export const Pagination = ({ data }) => {
  const pages = Math.floor(data.category.post_count / gamesPerPage + 1);

  if (pages === 1) {
    return null;
  }

  return (
    <div className="mt-4 flex items-center font-bold text-sm">
      <span className="mr-3">
        Page {data.currentPage} of {pages}
      </span>
      {data.currentPage > 1 && (
        (<Link
          href={`/category/${data.category.slug}/${data.currentPage === 2 ? "" : "page/" + (data.currentPage - 1)
            }`}
          className="inline-flex justify-center items-center w-8 h-8 rounded-full hover:bg-primary mr-1"
        >

          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-5 w-5"
            viewBox="0 0 20 20"
            fill="currentColor"
          >
            <path
              fillRule="evenodd"
              d="M9.707 16.707a1 1 0 01-1.414 0l-6-6a1 1 0 010-1.414l6-6a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l4.293 4.293a1 1 0 010 1.414z"
              clipRule="evenodd"
            />
          </svg>

        </Link>)
      )}

      {[...Array(pages)].map((_, index) => {
        const page = index + 1;
        if (data.currentPage === page) {
          return (
            <span key={index} className="inline-flex justify-center items-center w-8 h-8 rounded-full bg-primary mr-1">
              {page}
            </span>
          );
        }
        return (
          <Link
            href={`/category/${data.category.slug}/page/${page}`}
            key={index}
            className="inline-flex justify-center items-center w-8 h-8 rounded-full hover:bg-primary mr-1"
          >

            {page}

          </Link>
        );
      })}
      {data.currentPage !== pages && (
        (<Link
          href={`/category/${data.category.slug}/page/${data.currentPage + 1}`}
          className="inline-flex justify-center items-center w-8 h-8 rounded-full hover:bg-primary mr-1"
        >

          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-5 w-5"
            viewBox="0 0 20 20"
            fill="currentColor"
          >
            <path
              fillRule="evenodd"
              d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z"
              clipRule="evenodd"
            />
          </svg>

        </Link>)
      )}
    </div>
  );
};
